import { useQueries } from '@tanstack/react-query';
import {
  documentsFromListResponse,
  documentsOfTypeQueryOptions,
} from '../../../components/document-type-access';
import { WorkflowScopes } from '../../../constants/workflows';
import type { DocumentSectionSpec } from './DocumentSections';

/**
 * How many of a tab's REQUIRED document types have nothing on file for this clinician
 * (0 while loading — never flag before the answer is known). Reads the same cache
 * entries as the tab's `DocumentSections`, so opening the tab costs nothing more and
 * an upload there clears the flag.
 */
export function useMissingRequiredDocuments(
  providerId: string,
  types: readonly DocumentSectionSpec[]
): number {
  const required = types.filter((type) => type.required);
  const queries = useQueries({
    queries: required.map((type) =>
      documentsOfTypeQueryOptions({
        contextType: WorkflowScopes.Provider,
        contextId: providerId,
        documentTypeSlug: type.slug,
      })
    ),
  });
  return queries.filter(
    (query) => query.isSuccess && documentsFromListResponse(query.data).length === 0
  ).length;
}
